import { AirballoonIcon } from './AirballoonIcon';

/**
 * author: Austin Andrews
 * id 3E1D81B2-7DF1-4AAF-9598-4995B8D8E5CC
 * name airballoon
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/airballoon.svg
 * tags
 * - Transportation + Other 
 * - Transportation + Flying 
 */
export const HotAirBalloonIcon = AirballoonIcon;
export default HotAirBalloonIcon